@if (isMatMenu) {
  <button mat-menu-item
          [disabled]="fileDisbaled()"
          class="w-100"
          [ngClass]="cssClass"
          [matTooltip]="tooltip | translate"
          [matTooltipDisabled]="!isOfficeEditableDocument || !iconOnly"
          (click)="openEditOfficeUrl()"
          data-test="dms-edit-office-file-button-button">
    <i class="icon fa-fw fas fa-external-link-alt"></i>
    <span [hidden]="iconOnly" class="svg-label">{{ title }}</span>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [disabled]="fileDisbaled()"
             [label]="!iconOnly ? title : ''"
             [matTooltip]="tooltip | translate"
             [matTooltipDisabled]="!isOfficeEditableDocument || !iconOnly"
             (click)="openEditOfficeUrl()"
             data-test="dms-edit-office-file-button-button-2">
    @if (iconOnly) {
      <i class="icon fa-fw fas fa-external-link-alt"></i>
    } @else {
      <ng-template buttonPrefix>
        <i class="icon fa-fw fas fa-external-link-alt"></i>
      </ng-template>
    }
  </sk-button>
}
